export default function getServerModulesReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_SERVER_MODULES_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_SERVER_MODULES_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_SERVER_MODULES_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}